export default __webpack_public_path__ + "static/media/logo-horizontal.406bdbe6.png";